import React, { useMemo, useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ListLayout } from "components/common/ListLayout";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";

// Redux Slice
import { fetchCourtTypes, courtTypesSelector } from "slices/courtTypeSlice";

function CourtTypeList() {
  const dispatch = useDispatch();

  const {
    courtTypes,
    last_page: totalPages,
    loader,
    total,
    current_page,
    per_page: pageLength,
  } = useSelector(courtTypesSelector);

  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({
    sortBy: "name",
    sortDirection: "asc",
  });

  useEffect(() => {
    dispatch(fetchCourtTypes());
  }, [dispatch]);

  //#region TABLE HEADER
  const renderTableHeader = useCallback(() => {
    const callBack = (dir, sortBy) => {
      setSortConfig({ sortBy, sortDirection: dir });
      dispatch(
        fetchCourtTypes(current_page, {
          sortBy,
          sortDirection: dir,
          search: searchTerm,
        })
      );
    };

    return (
      <tr>
        <th className="col-1">#</th>

        <th className="col">
          <TableHeaderItem
            title="Court Type Name"
            sortBy="name"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col">
          <TableHeaderItem
            title="Court Type Code"
            sortBy="code"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col">
          <TableHeaderItem
            title="Created At"
            sortBy="created_at"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
      </tr>
    );
  }, [sortConfig, searchTerm, current_page]);
  //#endregion

  //#region TABLE BODY
  const renderTableContent = useCallback(() => {
    return courtTypes?.map((c, index) => (
      <CourtTypeItem
        key={c.id}
        courtType={c}
        index={index}
        current_page={current_page}
        pageLength={pageLength}
      />
    ));
  }, [courtTypes]);
  //#endregion

  return (
    <ListLayout
      heading="Court Types"
      buttonTitle="" // no add button
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      totalPages={totalPages}
      fetchList={fetchCourtTypes}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      loader={loader}
      disableBootstrap={true}
      noOfItems={total}
      searchPlaceholder="Search Court Type..."
      hideActions={true}
      addButtonDisabled={true}
    />
  );
}

const CourtTypeItem = ({ courtType, index, current_page, pageLength }) => {
  const serial = useMemo(
    () => index + 1 + (current_page - 1) * pageLength,
    [current_page, pageLength]
  );

  return (
    <tr>
      <td>{serial}</td>
      <td>{courtType.court_type_name}</td>
      <td>{courtType.court_type_code}</td>
      <td>{convertTimeToUTC(courtType.created_at)}</td>
    </tr>
  );
};

export default CourtTypeList;
